import UriEncoding from '@ms/odsp-utilities/lib/encoding/UriEncoding';
import Uri from '@ms/odsp-utilities/lib/uri/Uri';

// ************************************************************
// URL logic for List Item Forms
// ************************************************************

/**
 * ID (an integer) of the list item
 */
const listItemIdKey: string = 'ID';

/**
 * The URL that states where the user came from (for legacy SharePoint pages).
 * If Source is not present we should navigate user back to the root of the list.
 */
const sourceKey: string = 'Source';

/**
 * Root folder param for legacy SharePoint pages.
 */
const rootFolderParamKey: string = 'RootFolder';

/**
 * The content type id of the new list item to create
 */
const contentTypeIdParamKey: string = 'ContentTypeId';

export function getListItemFormUrl(
  aspxPageUrl: string,
  rootFolder: string,
  itemId?: string,
  contentTypeId?: string
): string {

  /* tslint:disable-next-line:no-any */
  const queryObj: any = {};
  queryObj[sourceKey] = UriEncoding.encodeURIComponent(window.location.href);
  queryObj[rootFolderParamKey] = UriEncoding.encodeURIComponent(rootFolder);

  // NewForm.aspx wouldn't have itemId
  if (itemId) {
    queryObj[listItemIdKey] = itemId;
  }

  // contentTypeId might not always exist
  if (contentTypeId) {
    queryObj[contentTypeIdParamKey] = contentTypeId;
  }

  // construct the uri
  const listUri: Uri = new Uri(aspxPageUrl);
  for (const queryKey in queryObj) {
    if (queryObj.hasOwnProperty(queryKey)) {
      listUri.setQueryParameter(queryKey, queryObj[queryKey]);
    }
  }
  return listUri.toString();
}
